import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"
import { useQueryClient } from "@tanstack/react-query";

export const useAddFromCsv = () => {

    const axios = useAxios();
    const {t} = useTranslation();
    const queryClient = useQueryClient();

    const addCsvFile = async (file: any, examTermId: string) => {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await axios.post(`/api/examterms/AddExamineesFromCsv/${examTermId}`, formData, {
                // headers: {
                //     'Content-Type': 'text/csv'
                // }
            });
            queryClient.invalidateQueries({queryKey: ["examPeriods", examTermId]});
            return response.data;
        } catch (error) {
            throw new Error(t("errors.attachmentAdd"));
        }
    }

    return {
        addCsvFile
    }
}